// Bosnian translations
export const bs: Record<string, string> = {
  'menu.dashboard': 'Kontrolna tabla',
  'menu.customers': 'Kupci',
  'menu.products': 'Proizvodi',
  'menu.users': 'Korisnici',
  'menu.settings': 'Postavke',
  'menu.logout': 'Odjava',
  'dashboard.title': 'Kontrolna tabla',
  'dashboard.newOrder': 'Nova narudžba',
  'order.title': 'Nova narudžba',
  'order.customer': 'Kupac',
  'order.products': 'Proizvodi',
  'order.total': 'Ukupno',
  'users.title': 'Korisnici',
  'users.name': 'Ime',
  'users.email': 'Email',
  'common.yes': 'Da',
  'common.no': 'Ne',
  'common.cancel': 'Otkaži',
  'common.save': 'Spremi',
  'common.search': 'Pretraži',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Prijava',
  'login.welcome': 'Dobrodošli, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Email',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Izvještaji i računovodstvo',
  'menu.systemAndCommunication': 'Sistem i komunikacija',
};